export function FoodTypeMark({ type, size = 14 }) {
  const palette = {
    veg: "#2E7D32",
    "non-veg": "#B91C1C",
    egg: "#D4A24E",
  };
  const color = palette[type] || palette["non-veg"];
  const isEgg = type === "egg";
  return (
    <span
      aria-label={type}
      data-testid={`food-mark-${type}`}
      className="inline-flex items-center justify-center shrink-0"
      style={{
        width: size,
        height: size,
        border: `1.5px solid ${color}`,
        borderRadius: 2,
      }}
    >
      <span
        style={{
          width: Math.round(size * 0.55),
          height: Math.round(size * 0.55),
          background: color,
          borderRadius: isEgg ? 999 : type === "veg" ? 999 : 1,
        }}
      />
    </span>
  );
}
